import { ChatButton } from "../types/chat-button";

export const chatButtonFallback: ChatButton = {
  styles: {
    cursor: 'pointer',
    borderRadius: '50%',
    border: 'none',
    width: '72px',
    height: '72px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    padding: '0',
  },
  openedIcon: {
    styles: {
      width: '60px',
      height: '60px'
    },
    src: '/assets/opened-chat-icon.svg'
  },
  closedIcon: {
    styles: {
      width: '60px',
      height: '60px',
    },
    src: '/assets/closed-chat-icon.svg'
  },
  buttonBlur: false
};